const publicAllowedUrlPaths = [
  '/',
  '/sign-up',
  '/verify-account',
  '/forgot-password',
  '/reset-password',
  '/reset-initiated',
  '/account-activation',
  '/resend-key',
  '/activate',
  '/workspace-otp',
  '/data-protection',
  '/subscription',
  '/unsubscribe',
  '/subscribed',
  '/data-protection/email',
  '/data-protection/success',
  '/data-protection/view',
  '/data-protection/update',
  '/data-protection/restrict',
  '/data-protection/delete',
  '/extension/login',
];

export default publicAllowedUrlPaths;
